import EnergyLabel from './EnergyLabel.js';
import { shouldRenderEnergyLabel } from './utils/shouldRenderEnergyLabel.js';
export { shouldRenderEnergyLabel };
export default EnergyLabel;
//# sourceMappingURL=index.js.map